// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__kEncE","spinnerTitle":"Spinner_spinnerTitle__t6pn1","spinner":"Spinner_spinner__Qz7DP","bounce":"Spinner_bounce__PCUdX"};